import React from 'react';
import { Alert } from '@mui/material';
import { useEditingPeers } from '../../context/PresenceContext';

// The notice names people by username only; the full name / email is just a
// fallback for a member whose username is blank.
const noticeName = (member) => (
  member.username || `${member.first_name || ''} ${member.last_name || ''}`.trim() || member.email
);

/**
 * Soft warning inside a row's edit dialog: "k.poom is also editing this".
 * Nothing is locked -- it only tells you. Renders nothing when you're alone.
 */
const ConcurrentEditNotice = ({ grid, rowId, sx }) => {
  // Same-page editors plus, for shared records (time entries), editors on
  // other pages of the teamspace -- e.g. Calendar vs Time Entries.
  const editors = useEditingPeers(grid, rowId);
  if (rowId == null || editors.length === 0) return null;
  // Plain commas, no "and": "ann.q, ben.q are also editing this."
  const names = editors.map((member) => noticeName(member)).join(', ');
  return (
    <Alert severity="info" variant="outlined" sx={{ py: 0, mb: 1.5, ...sx }}>
      {names} {editors.length === 1 ? 'is' : 'are'} also editing this.
    </Alert>
  );
};

export default ConcurrentEditNotice;
